import { render, staticRenderFns } from "./newTransport.vue?vue&type=template&id=4185eb9d&scoped=true&"
import script from "./newTransport.vue?vue&type=script&lang=js&"
export * from "./newTransport.vue?vue&type=script&lang=js&"
import style0 from "./newTransport.vue?vue&type=style&index=0&id=4185eb9d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4185eb9d",
  null
  
)

export default component.exports